module.exports = __webpack_public_path__ + "106ca38da3aee528b75571912788c85a.svg";